<div *ngIf="requisitionInfo && requisitionInfo.recruiters">
    <h2 class="text-center emerald requisition-card-recruiter-heading" *ngIf="requisitionInfo.recruiters.length>1" [ngClass]="{'purple': requisitionInfo.sharedRequisition && !isCorporateCompany && requisitionInfo.vendorRecruiters && requisitionInfo.vendorRecruiters.length==0}"> Recruiters</h2>
    <div class="row requisition-card-hiring-managers-popover-content-container">
        <div class="text-center recruiter-item"
            [ngClass]="{'col-xs-12':requisitionInfo.recruiters.length==1,
            'col-xs-6':requisitionInfo.recruiters.length<3,
            'col-xs-3':requisitionInfo.recruiters.length>=3 }" style="flex-grow: 1;"
            *ngFor="let recruiter of requisitionInfo.recruiters; trackBy: trackByIndex"
            [tooltip]="recruiter.name">
            <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg" [alt]="recruiter.name"
                [ngClass]="{'requisition-card-recruiter-img-other': vendorRecruitersNotAvailable}"
                class="requisition-card-hiring-manager-img img-responsive" />
            <span class="requisition-card-hiring-manager-name">
                {{recruiter.name}}
            </span>
        </div>
        <hr>
    </div>
</div>
